import React from "react";

const CreateAppTour = () => {
  return (
    <div>
      <p>
        Start building powerful AI chatbots and lead generation bots with just a
        few clicks.
      </p>
    </div>
  );
};

export default CreateAppTour;
